import React from "react";
import {Link} from "react-router-dom"
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Legend,
  CartesianGrid,
  LabelList,
  Line,
  LineChart
} from "recharts";
import "./dash.css";
const data = [
  { name: "Agriculture", value: 35 },
  { name: "Real Estate", value: 15 },
  { name: "Dairy Farm", value: 35 },
  { name: "Gold", value: 15 },
];
const bar1Data = [
  { month: "Jan", returns: 5 },
  { month: "Feb", returns: 8 },
  { month: "Mar", returns: 12 },
  { month: "Apr", returns: 15 },
  { month: "May", returns: 20 },
  { month: "Jun", returns: 24 },
  { month: "Jul", returns: 30 },
  { month: "Aug", returns: 35 },
  { month: "Sep", returns: 38 },
  { month: "Oct", returns: 45 },
  { month: "Nov", returns: 48 },
  { month: "Dec", returns: 50 },
];

const Dashboard = () => {
  const pieData = [
    { name: "Agriculture", value: 35 },
    { name: "Real Estate", value: 25 },
    { name: "Dairy Farm", value: 20 },
    { name: "Gold", value: 20 },
  ];

  const COLORS = ["#F8D47A", "#D6B656", "#C7A03D", "#F1E3A0"];

  const performanceData = [
    { name: "Agriculture", Risk: 30, Liquidity: 70, ROI: 85 },
    { name: "Real Estate", Risk: 45, Liquidity: 60, ROI: 80 },
    { name: "Dairy Farm", Risk: 40, Liquidity: 75, ROI: 78 },
    { name: "Gold", Risk: 20, Liquidity: 90, ROI: 65 },
  ];

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Investment Dashboard</h1>
      <div
      style={{
        width: "90%",
        maxWidth: "700px",
        height: "420px",
        margin: "auto",
        background: "#000",
        borderRadius: "20px",
        boxShadow: "0 4px 25px rgba(0,0,0,0.4)",
        padding: "25px",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          color: "#fce4a8",
          marginBottom: "25px",
          fontFamily: "Poppins, sans-serif",
          letterSpacing: "1px",
        }}
      >
        Investment Distribution
      </h2>

      <ResponsiveContainer width="100%" height="80%">
        <BarChart
          layout="vertical"
          data={data}
          margin={{ top: 10, right: 30, left: 60, bottom: 10 }}
        >
          <CartesianGrid stroke="#333" strokeDasharray="3 3" />
          <XAxis
            type="number"
            domain={[0, 100]}
            tickFormatter={(val) => `${val}%`}
            stroke="#fce4a8"
          />
          <YAxis
            dataKey="name"
            type="category"
            stroke="#fce4a8"
            tick={{ fill: "#fce4a8", fontSize: 14 }}
          />
          <Tooltip
            cursor={{ fill: "rgba(255,255,255,0.1)" }}
            contentStyle={{
              backgroundColor: "#111",
              border: "1px solid #fce4a8",
              color: "#fce4a8",
            }}
            formatter={(val) => `${val}%`}
          />
          <Bar
            dataKey="value"
            barSize={25}
            fill="#fce4a8"
            radius={[10, 10, 10, 10]}
            animationDuration={1200}
          >
            <LabelList
              dataKey="value"
              position="right"
              formatter={(val) => `${val}%`}
              style={{ fill: "#fce4a8", fontWeight: "bold" }}
            />
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill="#fce4a8" />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
    {/*
      <div className="cards-container">
        <div className="card" style={{color:"#F8D47A"}}>
          <h3>Total Investments</h3>
          <p>₹ 10,00,000</p>
        </div>
        <div className="card" style={{color:"#F8D47A"}}>
          <h3>Total Returns</h3>
          <p>₹ 2,40,000</p>
        </div>
        <div className="card" style={{color:"#F8D47A"}}>
          <h3>Active Plans</h3>
          <p>12</p>
        </div>
        <div className="card" style={{color:"#F8D47A"}}>
          <h3>Average ROI</h3>
          <p>14.8%</p>
        </div>
      </div>*/}

      {/* Pie Chart & Monthly Bar */}
      <div className="charts-container">
        <div className="chart-card">
          <h2>Investment Sector Distribution</h2>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) =>
                  `${name} ${(percent * 100).toFixed(0)}%`
                }
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/*<div className="chart-card">
          <h2>Monthly Returns Overview</h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={barData}>
              <XAxis dataKey="month" stroke="#F8D47A" />
              <YAxis stroke="#F8D47A" />
              <Tooltip />
              <Bar dataKey="returns" fill="#F8D47A" barSize={40} radius={[10, 10, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>*/}
        <div
      className="chart-card"
      style={{
        background: "#000",
        color: "#fce4a8",
        padding: "25px",
        borderRadius: "20px",
        boxShadow: "0 4px 25px rgba(0,0,0,0.4)",
        width: "90%",
        maxWidth: "700px",
        margin: "auto",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          color: "#fce4a8",
          fontFamily: "Poppins, sans-serif",
          marginBottom: "20px",
        }}
      >
        Monthly Returns Growth
      </h2>

      <ResponsiveContainer width="100%" height={320}>
        <LineChart data={bar1Data} margin={{ top: 10, right: 30, left: 10, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#333" />
          <XAxis dataKey="month" stroke="#fce4a8" tick={{ fill: "#fce4a8" }} />
          <YAxis stroke="#fce4a8" tick={{ fill: "#fce4a8" }} />
          <Tooltip
            contentStyle={{
              backgroundColor: "#111",
              border: "1px solid #fce4a8",
              color: "#fce4a8",
            }}
            cursor={{ stroke: "#fce4a8", strokeWidth: 1 }}
          />
          <Line
            type="monotone"
            dataKey="returns"
            stroke="#fce4a8"
            strokeWidth={3}
            dot={{ fill: "#fce4a8", r: 5 }}
            activeDot={{ r: 7, stroke: "#fce4a8", strokeWidth: 2 }}
            animationDuration={1200}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
      </div>

      {/* Horizontal Bars for Risk, Liquidity, ROI */}
      <div className="chart-card full-width">
        <h2>Risk, Liquidity & ROI by Sector</h2>
        <ResponsiveContainer width="100%" height={350}>
          <BarChart
            data={performanceData}
            layout="vertical"
            margin={{ top: 20, right: 30, left: 60, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(248, 212, 122, 0.2)" />
            <XAxis type="number" stroke="#F8D47A" />
            <YAxis dataKey="name" type="category" stroke="#F8D47A" />
            <Tooltip />
            <Legend />
            <Bar dataKey="Risk" fill="#C7A03D" barSize={15} radius={[0, 10, 10, 0]} />
            <Bar dataKey="Liquidity" fill="#F1E3A0" barSize={15} radius={[0, 10, 10, 0]} />
            <Bar dataKey="ROI" fill="#F8D47A" barSize={15} radius={[0, 10, 10, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insights Section */}
      <div className="summary-section">
        <h2>Company Insights</h2>
        <div className="insights">
          <div className="insight-card">
            <h3>Top Performing Sector</h3>
            <p>Agriculture – 35% portfolio share</p>
          </div>
          <div className="insight-card">
            <h3>Upcoming Focus</h3>
            <p>Real Estate expansion in Tier-2 cities</p>
          </div>
          <div className="insight-card">
            <h3>Customer Growth</h3>
            <p>Up by 18% in the last quarter</p>
          </div>
        </div>
      </div>
      <Link to="/"><button class="back">Back</button></Link>
    </div>
  );
};

export default Dashboard;
